import LPResultsPage from "./LPResultsPage";

export default function LPNewOfferResultsPage() {
  return <LPResultsPage lpSlug="newoffer" lpName="General" />;
}
